export type PublicApiResult<T> = {
  ok: boolean;
  status: number;
  url: string;
  data?: T;
  error?: string;
};

function joinUrl(base: string, path: string) {
  const trimmedBase = base.replace(/\/+$/, '');
  const trimmedPath = path.replace(/^\/+/, '');
  return `${trimmedBase}/${trimmedPath}`;
}

export async function fetchPublic<T>(path: string): Promise<PublicApiResult<T>> {
  const base =
    process.env.EXPO_PUBLIC_POSTGREST_URL ??
    (process.env.EXPO_PUBLIC_SUPABASE_URL
      ? `${process.env.EXPO_PUBLIC_SUPABASE_URL}/rest/v1`
      : (() => {
          throw new Error('Missing EXPO_PUBLIC_POSTGREST_URL and EXPO_PUBLIC_SUPABASE_URL');
        })());
  const anonKey = process.env.EXPO_PUBLIC_SUPABASE_ANON_KEY;
  if (!anonKey) {
    return {
      ok: false,
      status: 0,
      url: joinUrl(base, path),
      error: 'Missing EXPO_PUBLIC_SUPABASE_ANON_KEY',
    };
  }
  const jwt = process.env.EXPO_PUBLIC_POSTGREST_JWT;
  if (!jwt) {
    return {
      ok: false,
      status: 0,
      url: joinUrl(base, path),
      error: 'Missing EXPO_PUBLIC_POSTGREST_JWT',
    };
  }

  const url = joinUrl(base, path);
  try {
    const res = await fetch(url, {
      headers: {
        apikey: anonKey,
        Authorization: `Bearer ${jwt}`,
        Accept: 'application/json',
      },
    });

    const status = res.status;
    const text = await res.text();
    const contentType = res.headers.get('content-type') || '';
    if (!contentType.includes('application/json')) {
      return {
        ok: status >= 200 && status < 300,
        status,
        url,
        error: text.slice(0, 200),
      };
    }

    let data: T | undefined;
    try {
      data = JSON.parse(text) as T;
    } catch (err: any) {
      return {
        ok: false,
        status,
        url,
        error: `Invalid JSON: ${err?.message ?? 'parse error'}`,
      };
    }

    return {
      ok: status >= 200 && status < 300,
      status,
      url,
      data,
    };
  } catch (err: any) {
    return {
      ok: false,
      status: 0,
      url,
      error: err?.message ?? 'Request failed',
    };
  }
}
